/**
 * User Groups service
 *
 * @version
 * 4.71.0 OAUI-693 Tidy and remove duplicated code
 * 4.36.0 OAUI-502 Edit order details
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022-2024 Build Centrix
 */
import { Injectable } from '@angular/core';
import { isEmpty } from 'lodash';
import { IUserGroupModel } from '../../../interfaces/orders/order-interfaces';

@Injectable({
  providedIn: 'root',
})
export class WdUserGroupService {
  /**
   * Parse User Group
   *
   * @since 4.36.0
   * @memberof WdUserGroupService
   */
  static parseUserGroup(userGroup: any): IUserGroupModel {
    return {
      id: userGroup.id,
      label: userGroup.label,
    };
  }

  /**
   * Parse User Groups
   *
   * @since 4.36.0
   * @memberof WdUserGroupService
   */
  parseUserGroups(userGroupsArr: any): Array<any> {
    let userGroups: any = [];

    if (!isEmpty(userGroupsArr)) {
      userGroups = userGroupsArr.map((user: any) => {
        return WdUserGroupService.parseUserGroup(user);
      });
    }

    return userGroups;
  }
}
